import { render, staticRenderFns } from "./bottomR3.vue?vue&type=template&id=7dc61d14&scoped=true&"
import script from "./bottomR3.vue?vue&type=script&lang=js&"
export * from "./bottomR3.vue?vue&type=script&lang=js&"
import style0 from "./bottomR3.vue?vue&type=style&index=0&id=7dc61d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc61d14",
  null
  
)

export default component.exports